module.exports = __webpack_public_path__ + "img/icon-order-process.2c33d558.png";